import AbstractTextInput from "./AbstractTextInput";
import Rules from "../../../../../config/rules";

class TextInput extends AbstractTextInput
{
    validators = !this.props.isOptional ? ['required'] : []

    errorMessages = !this.props.isOptional ? [Rules.txtRequis] : []

}

export default TextInput
